import { render, staticRenderFns } from "./umat.vue?vue&type=template&id=a6ef3116&"
import script from "./umat.vue?vue&type=script&lang=js&"
export * from "./umat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports